import * as Sentry from '@sentry/nextjs'
import { AxiosError, isAxiosError } from 'axios'

import { isServer } from '@nx/helpers'
import { removeAuthCookies } from '@nx/user-auth-cookies'
import { logger } from '@nx/utils/logger'

const DEFAULT_STATUS = 500

export function returnError({
  error,
  removeLogin = false,
  message,
}: {
  error: AxiosError | Error
  removeLogin?: boolean
  message?: string
}) {
  if (removeLogin && !isServer()) {
    removeAuthCookies()
  }

  const hasAxiosError = isAxiosError(error)
  const axiosErrorCode =
    hasAxiosError && error.code ? Number(error.code) : undefined

  const status = hasAxiosError
    ? (error.response?.status ?? (axiosErrorCode || DEFAULT_STATUS))
    : // istanbul ignore next
      DEFAULT_STATUS

  Sentry.captureException(error, { data: { message } })
  logger.error(error, message)

  return Promise.reject({
    status,
    message: message || error.message || undefined,
    error,
  })
}
